/* eslint-disable no-unused-vars */
import api from '@utils/api'

export const getSearchSuplier = (search) => async (_dispatch, _getState) => {
  const querys = {
    search
  }
  const response = await api.getSearchSuplier(querys)
  return response
}

export const updateSupplier  = (data) => async (_dispatch, _getState) => {
  const response = await api.updataSupplier(data)
  return response;
};
